import script from "./vehicleLedger.vue?vue&type=script&setup=true&lang=js"
export * from "./vehicleLedger.vue?vue&type=script&setup=true&lang=js"

import "./vehicleLedger.vue?vue&type=style&index=0&id=76508fc6&lang=scss"

const __exports__ = script;

export default __exports__